// extracted by mini-css-extract-plugin
export default {"payoutContainer":"ShippingPreferenceModal_payoutContainer__NaJLu","form":"ShippingPreferenceModal_form__2iEV7"};